/* PICADIX — interacciones propias (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.px-reveal:not(.px-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('px-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('px-visible');
        io.unobserve(en.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function initCifras(root) {
    var nums = (root || document).querySelectorAll('[data-px-count]');
    if (!nums.length) return;
    function fmt(n, dec) { return n.toLocaleString('es-ES', { minimumFractionDigits: dec, maximumFractionDigits: dec }); }
    function run(el) {
      var fin = parseFloat(el.getAttribute('data-px-count')) || 0;
      var dec = parseInt(el.getAttribute('data-px-dec') || '0', 10);
      var pre = el.getAttribute('data-px-pre') || '', suf = el.getAttribute('data-px-suf') || '';
      if (reduce) { el.textContent = pre + fmt(fin, dec) + suf; return; }
      var t0 = null, dur = 1800;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
        el.textContent = pre + fmt(fin * e, dec) + suf;
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { nums.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  function initComparador(root) {
    (root || document).querySelectorAll('.px-comp').forEach(function (c) {
      var r = c.querySelector('.px-comp__rango');
      if (!r || c.dataset.pxIni) return;
      c.dataset.pxIni = '1';
      var manual = false;
      var set = function (v) { r.value = v; c.style.setProperty('--px-pos', v + '%'); };
      r.addEventListener('input', function () { manual = true; set(r.value); });
      ['pointerdown', 'touchstart'].forEach(function (ev) { c.addEventListener(ev, function () { manual = true; }, { passive: true }); });
      set(r.value);
      if (reduce || c.getAttribute('data-px-auto') !== 'true') return;
      // Scroll: al entrar la sección la barra va de "antes" (100) a "después" (0)
      var ini = parseFloat(c.getAttribute('data-px-desde') || '92'), fin = parseFloat(c.getAttribute('data-px-hasta') || '8');
      set(ini);
      var tic = false;
      function onScroll() {
        if (manual) { window.removeEventListener('scroll', onScroll); return; }
        if (tic) return; tic = true;
        requestAnimationFrame(function () {
          tic = false;
          var b = c.getBoundingClientRect(), vh = window.innerHeight;
          // progreso 0 cuando el centro del comparador está al 85% de la pantalla, 1 cuando llega al 35%
          var centro = b.top + b.height / 2;
          var p = (vh * 0.85 - centro) / (vh * 0.5);
          p = Math.max(0, Math.min(1, p));
          var e = p < .5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
          set(Math.round((ini + (fin - ini) * e) * 10) / 10);
        });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    });
  }

  function initGaleria(root) {
    (root || document).querySelectorAll('[data-px-galeria]').forEach(function (g) {
      var principal = g.querySelector('.px-pdp__principal img');
      var minis = Array.prototype.slice.call(g.querySelectorAll('.px-pdp__mini'));
      if (!principal || !minis.length) return;
      var idx = 0;
      function ir(i) {
        idx = (i + minis.length) % minis.length;
        var m = minis[idx];
        principal.src = m.getAttribute('data-src');
        principal.srcset = m.getAttribute('data-srcset') || '';
        principal.alt = m.getAttribute('data-alt') || '';
        minis.forEach(function (x, k) { x.setAttribute('aria-current', k === idx ? 'true' : 'false'); });
      }
      minis.forEach(function (m, k) { m.addEventListener('click', function () { ir(k); }); });
      var prev = g.querySelector('.px-pdp__flecha--prev'), next = g.querySelector('.px-pdp__flecha--next');
      if (prev) prev.addEventListener('click', function () { ir(idx - 1); });
      if (next) next.addEventListener('click', function () { ir(idx + 1); });
      var x0 = null, cont = g.querySelector('.px-pdp__principal');
      cont.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      cont.addEventListener('touchend', function (e) {
        if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) ir(idx + (dx < 0 ? 1 : -1)); x0 = null;
      });
    });
  }

  function initProducto(root) {
    (root || document).querySelectorAll('[data-px-producto]').forEach(function (p) {
      var input = p.querySelector('.px-cant input');
      p.querySelectorAll('.px-cant button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          v += b.getAttribute('data-px-delta') === '+' ? 1 : -1;
          input.value = Math.max(1, Math.min(99, v));
        });
      });
      var datos = p.querySelector('[data-px-variantes]');
      var sel = p.querySelector('.px-pdp__variantes select');
      if (datos && sel) {
        var variantes = JSON.parse(datos.textContent);
        sel.addEventListener('change', function () {
          var v = variantes.find(function (x) { return String(x.id) === sel.value; });
          if (!v) return;
          p.querySelector('input[name="id"]').value = v.id;
          var fmt = function (c) { return (c / 100).toLocaleString('es-ES', { style: 'currency', currency: p.getAttribute('data-px-moneda') || 'EUR' }); };
          p.querySelectorAll('[data-px-precio]').forEach(function (e) { e.textContent = fmt(v.price); });
          p.querySelectorAll('[data-px-antes]').forEach(function (e) { e.textContent = v.compare_at_price > v.price ? fmt(v.compare_at_price) : ''; });
          p.querySelectorAll('[data-px-boton]').forEach(function (b) { b.disabled = !v.available; });
        });
      }
      var barra = document.querySelector('.px-pdp__barra');
      var boton = p.querySelector('[data-px-boton]');
      if (barra && boton && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var fuera = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
          barra.classList.toggle('px-visible-barra', fuera);
        }).observe(boton);
        var bb = barra.querySelector('button');
        if (bb) bb.addEventListener('click', function () { boton.click(); });
      }
    });
  }

  function copiar(texto) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(texto);
    return new Promise(function (ok) {
      var t = document.createElement('textarea'); t.value = texto; t.style.position = 'fixed'; t.style.opacity = '0';
      document.body.appendChild(t); t.select(); try { document.execCommand('copy'); } catch (e) {} t.remove(); ok();
    });
  }
  // Delegado: funciona también cuando el carrito se vuelve a pintar
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-px-copiar]');
    if (!b) return;
    e.preventDefault();
    var codigo = b.getAttribute('data-px-copiar');
    var label = b.querySelector('[data-px-label]');
    copiar(codigo).then(function () {
      b.classList.add('px-copiado');
      if (label) { var orig = label.getAttribute('data-orig') || label.textContent; label.setAttribute('data-orig', orig); label.textContent = b.getAttribute('data-px-ok') || '¡Copiado!'; }
      setTimeout(function () { b.classList.remove('px-copiado'); if (label) label.textContent = label.getAttribute('data-orig'); }, 2200);
    });
  });

  function initVideos(root) {
    (root || document).querySelectorAll('video[data-px-auto]').forEach(function (v) {
      v.muted = true;
      if (!('IntersectionObserver' in window)) { v.play().catch(function () {}); return; }
      new IntersectionObserver(function (en) {
        en.forEach(function (x) { if (x.isIntersecting) v.play().catch(function () {}); else v.pause(); });
      }, { threshold: 0.25 }).observe(v);
    });
  }

  function initTodo(root) { initReveal(root); initCifras(root); initComparador(root); initGaleria(root); initProducto(root); initVideos(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  else initTodo();
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
